export default "__VITE_ASSET__9534cf5b__"